export default __webpack_public_path__ + "static/media/s1-bg-3x.a7982bd5.png";